import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	blankText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	emptyCardText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	blankTextIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	emptyCardTextIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tooltipIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	blankText: {
		id: 'issue-navigator.issue-results.detail-view.card-list.card.empty-card.blank-text',
		defaultMessage: "We can't display this issue",
		description: 'Text that shows when an issue can no longer be opened from the issue navigator',
	},
	emptyCardText: {
		id: 'issue-navigator.issue-results.detail-view.card-list.card.empty-card.empty-card-text',
		defaultMessage:
			'This issue cannot be opened because it may have been deleted or you do not have access to it',
		description: 'Text that shows when an issue can no longer be opened from the issue navigator',
	},
	tooltip: {
		id: 'issue-navigator.issue-results.detail-view.card-list.card.empty-card.tooltip',
		defaultMessage: 'Either this issue has been deleted, or you don’t have access to it.',
		description: 'Tooltip text for blank issue information icon',
	},
	blankTextIssueTermRefresh: {
		id: 'issue-navigator.issue-results.detail-view.card-list.card.empty-card.blank-text-issue-term-refresh',
		defaultMessage: "We can't display this work item",
		description: 'Text that shows when an issue can no longer be opened from the issue navigator',
	},
	emptyCardTextIssueTermRefresh: {
		id: 'issue-navigator.issue-results.detail-view.card-list.card.empty-card.empty-card-text-issue-term-refresh',
		defaultMessage:
			'This work item cannot be opened because it may have been deleted or you do not have access to it',
		description: 'Text that shows when an issue can no longer be opened from the issue navigator',
	},
	tooltipIssueTermRefresh: {
		id: 'issue-navigator.issue-results.detail-view.card-list.card.empty-card.tooltip-issue-term-refresh',
		defaultMessage: 'Either this work item has been deleted, or you don’t have access to it.',
		description: 'Tooltip text for blank issue information icon',
	},
});
export default messages;
